import { DeviceMeasurementSummary } from "../../../Api/mes.api";
import { t, dateLocale } from "../../../i18n/locale";

export type LotStatus = "quarantine" | "released" | "rejected" | string;

export function formatHrDate(value?: string | Date | null): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(dateLocale());
}

export function formatHrDateTime(value?: string | Date | null): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(dateLocale(), { dateStyle: "short", timeStyle: "short" });
}

export function formatNum(value?: number | string | null, digits = 2): string {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString(dateLocale(), { maximumFractionDigits: digits });
}

export function lotStatusLabel(status: LotStatus): { label: string; className: string } {
  switch (status) {
    case "quarantine":
      return { label: t("Karantena"), className: "badge badge-quarantine" };
    case "released":
      return { label: t("Pušten"), className: "badge stock-good" };
    case "rejected":
      return { label: t("Odbijen"), className: "badge badge-danger" };
    default:
      return { label: status, className: "badge badge-muted" };
  }
}

export function deviceSummaryBadge(s: DeviceMeasurementSummary | undefined) {
  if (!s || s.count === 0) return { label: t("Nema testa"), className: "fq-device-badge fq-device-none" };
  if (s.has_valid) return { label: t("Valjano"), className: "fq-device-badge fq-device-ok" };
  return { label: t("Nepregledano"), className: "fq-device-badge fq-device-pending" };
}
